import { render } from "./RedeemGiftCards.vue?vue&type=template&id=2b37d59f"
import script from "./RedeemGiftCards.vue?vue&type=script&lang=js"
export * from "./RedeemGiftCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__